import React, { useState } from 'react';
import parse from 'html-react-parser';
export default function TextNote({ shortNote, longNote }) {
    const [showLongNote, setShowLongNote] = useState(false);
    return (React.createElement("div", null,
        React.createElement("div", null,
            React.createElement("div", { className: "display-text note-short" }, parse(shortNote)),
            React.createElement("div", null, longNote && (React.createElement("button", { className: "open-modal-button", onClick: () => setShowLongNote(true) }, "Read More")))),
        showLongNote && longNote && (React.createElement("div", null,
            React.createElement("div", { className: "modal", role: "dialog" },
                React.createElement("div", { className: "modal-overlay" },
                    React.createElement("div", { className: "modal-content" },
                        React.createElement("button", { "data-testid": "modal-close", className: "modal-close", "aria-label": "close modal", onClick: () => setShowLongNote(false) }),
                        React.createElement("div", { className: "display-text note-long" }, parse(longNote)))))))));
}
//# sourceMappingURL=TextNote.js.map